module.exports = __webpack_public_path__ + "assets/img/10.ea4d7c3d.png";